import messages_de from "./Common/localization/Translations/de.json"
import messages_da from "./Common/localization/Translations/da.json"
import messages_en from "./Common/localization/Translations/en.json"
import messages_us from "./Common/localization/Translations/en-us.json"
import messages_au from "./Common/localization/Translations/en-au.json"
import messages_no from "./Common/localization/Translations/no.json"
import messages_sv from "./Common/localization/Translations/sv.json"
import React from "react"
import { IntlProvider } from "react-intl"
import { globalConfig } from "./Common/configuration/config";


export default function LocalizationProvider({ children }: { children: React.ReactNode }) {
    const messages: { [index: string]: any } = {
        "de": messages_de,
        "da": messages_da,
        "no": messages_no,
        "sv": messages_sv
    }
    if (globalConfig.config.Region === "US") {
        messages["en"] = messages_us;
    }
    else if (globalConfig.config.Region === "AU") {
        messages["en"] = messages_au;
    }
    else {
        messages["en"] = messages_en;
    }
    let language: string;
    try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        language = urlParams.get('ui_locales') || '';
        language = language.split('-')[0];
        if (!language || !messages.hasOwnProperty(language)) {
            language = globalConfig.config.DefaultLanguage;
        }
    }
    catch {
        language = globalConfig.config.DefaultLanguage;
    }


    const translations = messages[language];

    return (
        <IntlProvider locale={language} messages={translations}>
            {children}
        </IntlProvider>
    );
}
